import React, { useState } from 'react';
import Button from '../buttons/Button';
import { IconClose } from '../Icons';

const ConfirmModal = ({
  icon,
  title,
  message,
  cancel,
  confirm,
  onSuccess,
  onClose,
  className = '',
  ContentComponent,
  btnConfirmClassName = 'p-0',
  titleClassName = '',
  footerClassName = 'justify-content-end',
  showCloseButton = true,
  contentClassName = 'px-v2-12 pt-v2-12 pb-v2-16',
}) => {
  const [fetching, setFetch] = useState(false);

  const handleConfirmClick = async () => {
    if (fetching) return;
    setFetch(true);
    if (onSuccess) await onSuccess();
    setFetch(false);
    onClose();
  };

  return (
    <div className={`confirm-modal position-relative ${className}`}>
      {showCloseButton && (
        <div
          className='close-button position-absolute r-4 t-4'
          role='button'
          tabIndex={0}
          onClick={onClose}
        >
          <IconClose />
        </div>
      )}
      <div className={`${contentClassName}`}>
        {title && (
          <p
            className={`text-md-alt weight-500 mb-v2-8 d-flex align-items-center ${titleClassName ||
              ''}`}
          >
            {icon && icon}
            <span className={icon ? 'ml-v2-6' : ''}>{title}</span>
          </p>
        )}
        {message && (
          <p className='text-sm-alt weight-400 text-v2-light-alt mb-0 overflow-hidden'>{message}</p>
        )}
        {ContentComponent && <ContentComponent onClose={onClose} />}
      </div>
      <div
        className={`d-flex align-items-center px-v2-14 py-v2-8 border-top border__extra_dark ${footerClassName}`}
      >
        {cancel && (
          <Button
            type='button'
            appearance=''
            className='text-v2-extra-light text-uppercase p-0'
            onClick={onClose}
          >
            {cancel}
          </Button>
        )}
        {confirm && (
          <Button
            type='button'
            appearance=''
            className={`text-uppercase ml-v2-12 ${btnConfirmClassName}`}
            disabled={fetching}
            onClick={handleConfirmClick}
          >
            {confirm}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ConfirmModal;
